export default __webpack_public_path__ + "static/checkout-page-returning-d499c329ddac994fb418a3b9db8973fe.png";